import { Injectable } from "@angular/core";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { HttpHeaders } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class ConfigService {
  constructor(private translate: TranslateService) { }
  lang = this.getItem('lang');
  header = new HttpHeaders({
    'Content-Type': 'application/json',
    authorization: this.getItem('token') || '',
    lan: this.lang ? this.lang : 'en'
  });

  // Login response
  setItem(values) {
    Cookie.set('token', values.token, 5, '/');
    Cookie.set('email', values.email, 5, '/');
    Cookie.set('firstName', values.firstName, 5, '/');
    Cookie.set('devid', values.fingerprint, 5, '/');
    Cookie.set('sid', values.sid, 5, '/');
    Cookie.set('profilePic', values.Location, 5, '/');
    Cookie.set('phone', values.phone, 5, '/');
    Cookie.set('mqttTopic', values.mqttTopic, 5, '/');
    this.header = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: values.token || '',
      lan: this.lang ? this.lang : 'en'
    });
  }
  getItem(va) {
    return Cookie.get(va);
  }
  setItems(name, val) {
    Cookie.set(name, val, 5, '/');
  }

  // config
  setConfig(values) {
    Cookie.set('customerApiInterval', values.customerApiInterval, 5, '/');
    Cookie.set('stripe', values.stripePublishKey, 5, '/');
    Cookie.set('someone', values.isBookingForSomeoneElseEnable, 5, '/');
  }

  // config
  setSetting(values) {
    Cookie.set('accountType', values.accountType, 5, '/');
    Cookie.set('sid', values.sid, 5, '/');
    Cookie.set('token', values.token, 5, '/');
    Cookie.set('countryCode', values.countryCode, 5, '/');
    Cookie.set('phoneNumber', values.phone, 5, '/');
  }

  getConfig(va) {
    return Cookie.get(va);
  }

  getSettings(value) {
    return Cookie.get(value);
  }

  getHeaders() { }

  // remove item
  removeItem() {
    Cookie.delete('token');
  }

  // fare estimate
  setFareEstimate(values) {
    Cookie.set('timeFee', values.timeFee, 5, '/');
    Cookie.set('distance', values.distance, 5, '/');
    Cookie.set('distanceFee', values.distanceFee, 5, '/');
    Cookie.set('duration', values.duration, 5, '/');
  }
  getFareEstimate(va) {
    return Cookie.get(va);
  }

  // Book Now
  setBookNow(values) {
    Cookie.set('bookingId', values.bookingId, 5, '/');
  }
  getBookNow(va) {
    return Cookie.get(va);
  }

  // Book Now
  setForgotPass(values) {
    Cookie.set('sid', values.sid, 5, '/');
  }
  getForgotPass(va) {
    return Cookie.get(va);
  }

  // wallet details
  setWalletDetails(values) {
    Cookie.set('walletBalance', values.walletBalance, 5, '/');
    Cookie.set('isEnabled', values.isEnabled, 5, '/');
    Cookie.set('currencySymbol', values.currencySymbol, 5, '/');
    Cookie.set('walletSoftLimit', values.walletSoftLimit, 5, '/');
    Cookie.set('walletHardLimit', values.walletHardLimit, 5, '/');
  }
  getWalletDetails(va) {
    return Cookie.get(va);
  }

  // Profile Details
  setProfile(values) {
    Cookie.set('firstName', values.firstName, 5, '/');
    Cookie.set('lastName', values.lastName, 5, '/');
    Cookie.set('email', values.email, 5, '/');
    Cookie.set('phone', values.phone, 5, '/');
    Cookie.set('profilePic', values.profilePic, 5, '/');
  }
  getProfile(va) {
    return Cookie.get(va);
  }

  setNewCookie(name, value, days?) {
    Cookie.set(name, value, days ? days : 1);
  }
  getLanguageTexts() {
    let lang = this.getItem('lang');
    console.log('lang', lang);
    this.translate.getTranslation(lang).subscribe((res: string) => {
      console.log("translate", res);
      return res;
      //=> 'hello world'
    });
  }
}
